import { view, utils } from '@yola/ws-sdk';
import { targetClasses } from 'src/js/modules/element-settings/constants/target-classes';
import controlUnits from '../constants/control-units';

const SUPPORTED_UNITS = [controlUnits.PX];

const TARGET_TO_CSS_BORDER_RADIUS_PROPERTY = {
  [targetClasses.ROUNDED_TOP_LEFT]: 'border-top-left-radius',
  [targetClasses.ROUNDED_TOP_RIGHT]: 'border-top-right-radius',
  [targetClasses.ROUNDED_BOTTOM_LEFT]: 'border-bottom-left-radius',
  [targetClasses.ROUNDED_BOTTOM_RIGHT]: 'border-bottom-right-radius',
};

const FALLBACK_VALUE = '4px';

const computeCornersFallback = ({ elementId, target }) => {
  const element = view.accessors.getLiveElement(elementId);

  if (!element) {
    return FALLBACK_VALUE;
  }

  const computedValue = getComputedStyle(element)
    .getPropertyValue(TARGET_TO_CSS_BORDER_RADIUS_PROPERTY[target])
    ?.trim();
  const parsedValue = parseFloat(computedValue);

  if (!utils.isNumeric(parsedValue) || parsedValue <= 0) {
    return FALLBACK_VALUE;
  }

  const unit = SUPPORTED_UNITS.find((item) => computedValue?.endsWith(item));
  const hasSupportedUnit = Boolean(unit);

  if (!hasSupportedUnit) {
    return FALLBACK_VALUE;
  }

  return `${parsedValue}${unit}`;
};

export default computeCornersFallback;
